import axios from 'axios';
import store from '../redux/store/store';
const API_PRINT_TEMPLATE_SETTING_URL = import.meta.env.VITE_API_URL;

const printTemplateSettingService = {
  getPrintTemplateSetting: (userId) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.get(`${API_PRINT_TEMPLATE_SETTING_URL}/PrintTemplateSetting?UserId=${userId}`, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },

  addPrintTemplateSetting: (data) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.post(`${API_PRINT_TEMPLATE_SETTING_URL}/PrintTemplateSetting`, data, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },

  printTemplateSettingUpdateApi: (data) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.put(`${API_PRINT_TEMPLATE_SETTING_URL}/PrintTemplateSetting`, data, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },
};

export default printTemplateSettingService;
